import ActiveCountryService from "@/services/ActiveCountryService";
const state = () => ({
  listDestCountries: [],
  listSourceCountries: []
});

const getters = {
  getListDestCountries: state => state.listDestCountries,
  getListSourceCountries: state => state.listSourceCountries
};

const mutations = {
  setListDestCountries(state, value) {
    state.listDestCountries = value;
  },
  setListSourceCountries(state, value) {
    state.listSourceCountries = value;
  }
};

const actions = {
  getList({ commit }, payload) {
    return ActiveCountryService.getList(payload).then(
      ({
        destCountries: listDestCountries,
        sourceCountries: listSourceCountries
      }) => {
        commit("setListDestCountries", listDestCountries);
        commit("setListSourceCountries", listSourceCountries);
      }
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
